import React from 'react';

const CGU: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo192.png" alt="SmartResell" className="w-8 h-8 rounded-xl" />
            <span className="font-bold text-lg" style={{ color: '#0d9488' }}>SmartResell</span>
          </div>
          <a href="/" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">← Retour</a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Conditions Générales d'Utilisation</h1>
        <p className="text-sm text-gray-400 mb-10">Dernière mise à jour : 2026-04-18</p>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 1 — Objet et description du service</h2>
          <p className="text-gray-700 leading-relaxed">
            SmartResell (ci-après « le Service ») est une application web permettant aux utilisateurs de suivre les prix d'articles publiés sur la plateforme Vinted, de gérer leurs achats, ventes, stocks et comptabilité, et de générer des documents à usage interne. SmartResell n'est pas affilié à Vinted ni à aucune autre marketplace.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 2 — Plans d'abonnement et limitations</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            SmartResell propose plusieurs plans d'abonnement :
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li><strong>Gratuit</strong> : CRM limité à 10 ventes, 10 achats, 10 articles en stock. Scraping des prix désactivé.</li>
            <li><strong>Starter</strong> : CRM illimité. Scraping des prix désactivé.</li>
            <li><strong>Hunter</strong> : CRM illimité + 25 recherches de prix par mois.</li>
            <li><strong>Business</strong> : CRM illimité + 100 recherches de prix par mois.</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            SmartResell se réserve le droit de modifier les tarifs et les limites des plans à tout moment, avec notification préalable aux utilisateurs abonnés.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 3 — Utilisation équitable et anti-abus</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Afin de garantir un accès équitable au Service, les mesures suivantes sont en vigueur :
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li>L'adresse Gmail Vinted configurée pour la synchronisation CRM est enregistrée de manière permanente. Elle ne peut être associée qu'à un seul compte SmartResell, même après suppression du compte.</li>
            <li>Toute tentative de contournement des limites du plan gratuit (création de multiples comptes, etc.) est interdite et peut entraîner la suspension du ou des comptes concernés.</li>
            <li>La synchronisation automatique des emails est réservée aux utilisateurs résidant en France à ce jour.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 4 — Compte utilisateur</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            L'accès au Service nécessite la création d'un compte. L'utilisateur est responsable de la confidentialité de son compte et de l'ensemble des actions effectuées sous celui-ci. Toute utilisation frauduleuse doit être signalée immédiatement à <a href="mailto:contact@smart-resell.com" className="text-teal-600 hover:underline">contact@smart-resell.com</a>.
          </p>
          <p className="text-gray-700 leading-relaxed">
            SmartResell se réserve le droit de suspendre ou supprimer tout compte en cas de violation des présentes CGU, sans préavis ni indemnité.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 5 — Licence d'utilisation</h2>
          <p className="text-gray-700 leading-relaxed">
            SmartResell accorde à l'utilisateur une licence personnelle, non exclusive, non transférable et révocable d'accès et d'utilisation du Service. L'utilisateur s'interdit notamment de reproduire, modifier, distribuer, vendre ou exploiter commercialement tout ou partie du Service sans autorisation écrite préalable.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 6 — Données et confidentialité</h2>
          <p className="text-gray-700 leading-relaxed">
            Le traitement des données personnelles est décrit dans la Politique de confidentialité disponible à l'adresse <a href="/confidentialite" className="text-teal-600 hover:underline">/confidentialite</a>. L'utilisateur consent à ce traitement en utilisant le Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 7 — Limites d'utilisation</h2>
          <p className="text-gray-700 leading-relaxed mb-3">Il est interdit d'utiliser le Service pour :</p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li>Contourner des mesures de protection techniques</li>
            <li>Créer plusieurs comptes pour contourner les limites du plan gratuit</li>
            <li>Effectuer du scraping automatisé non autorisé</li>
            <li>Porter atteinte aux droits de tiers</li>
            <li>Toute activité illégale ou contraire aux bonnes mœurs</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 8 — Documents générés</h2>
          <p className="text-gray-700 leading-relaxed">
            Les documents générés par le Service (bordereaux recadrés, étiquettes, factures, exports comptables) sont fournis à titre indicatif et à usage interne uniquement. SmartResell ne garantit pas leur conformité à des exigences légales ou réglementaires spécifiques. L'utilisateur demeure seul responsable de l'usage qu'il en fait.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 9 — Disponibilité du Service</h2>
          <p className="text-gray-700 leading-relaxed">
            SmartResell s'efforce d'assurer la disponibilité du Service 24h/24 et 7j/7, mais ne peut garantir une disponibilité sans interruption. Des interruptions pour maintenance ou en cas de force majeure peuvent survenir.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 10 — Services tiers</h2>
          <p className="text-gray-700 leading-relaxed">
            Le Service recourt à des services tiers (Google OAuth, Hetzner, ForwardEmail, Stripe, Cloudflare). SmartResell n'est pas responsable du fonctionnement ou des pratiques de ces services tiers.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 11 — Responsabilité</h2>
          <p className="text-gray-700 leading-relaxed">
            SmartResell est fourni "en l'état". Dans toute la mesure permise par la loi applicable, SmartResell exclut toute garantie expresse ou implicite et ne saurait être tenu responsable de dommages indirects, accessoires, spéciaux ou consécutifs résultant de l'utilisation ou de l'impossibilité d'utiliser le Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 12 — Modifications des CGU</h2>
          <p className="text-gray-700 leading-relaxed">
            SmartResell se réserve le droit de modifier les présentes CGU à tout moment. Les modifications entrent en vigueur dès leur publication. L'utilisation continue du Service après publication vaut acceptation des CGU modifiées.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 13 — Suspension et résiliation</h2>
          <p className="text-gray-700 leading-relaxed">
            L'utilisateur peut supprimer son compte à tout moment en contactant <a href="mailto:contact@smart-resell.com" className="text-teal-600 hover:underline">contact@smart-resell.com</a>. SmartResell se réserve le droit de suspendre ou résilier l'accès au Service à tout utilisateur qui ne respecterait pas les présentes CGU.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#0d9488' }}>Article 14 — Droit applicable</h2>
          <p className="text-gray-700 leading-relaxed">
            Les présentes CGU sont régies par le droit français. Tout litige relatif à leur interprétation ou exécution sera soumis à la compétence exclusive des tribunaux français compétents, après tentative de résolution amiable.
          </p>
        </section>

        <div className="mt-12 pt-8 border-t border-gray-100 text-center text-sm text-gray-400">
          Pour toute question : <a href="mailto:contact@smart-resell.com" className="text-teal-600 hover:underline">contact@smart-resell.com</a>
        </div>
      </main>
    </div>
  );
};

export default CGU;
